<template>
  <div class="condition-item">
    <property-selector
      :size="size"
      :show-total="false"
      :condition-property-options="conditionPropertyOptions"
      :all-event-event-property-list="allEventEventPropertyList"
      :filter-events="filterEvents"
      :filter-property-fn="filterPropertyFn"
      @change="onPropertyChange"
      v-model="column"
      class="condition-item-ele"
      :disabled="disabled"
    ></property-selector>
    <t-select
      :size="size"
      @change="onOperatorChange"
      v-model="conditionOperator"
      :options="operatorOptions"
      placeholder="请选择"
      class="condition-item-ele width100"
      :disabled="disabled"
    ></t-select>

    <template v-if="(isUserTag || isFirst) && (isMultiValue || isSingleValue)">
      <t-select
        v-model="value"
        :multiple="isMultiValue"
        filterable
        creatable
        :placeholder="isMultiValue ? '请添加' : '请选择'"
        :size="size"
        :options="valueOptions"
        class="condition-item-ele width208"
        @create="createValueOptions"
        @change="onValueChange"
        :minCollapsedNum="1"
        :disabled="disabled"
        :clearable="true"
      >
        <template #collapsedItems="{ collapsedSelectedItems, count }">
          <t-popup>
            <template #content>
              <p v-for="(item, index) in collapsedSelectedItems" :key="index" style="padding: 10px">
                {{ item.label }}
              </p>
            </template>
            <t-tag v-show="count > 0" style="color: #222">...</t-tag>
          </t-popup>
        </template>
      </t-select>
    </template>
    <template v-else>
      <template v-if="conditionOperator === 'betweenNumber'">
        <between-input
          v-model="value"
          :size="size"
          class="condition-item-ele"
          @onChange="onValueChange"
          @input="onValueChange"
          :disabled="disabled"
        ></between-input>
      </template>
      <template v-else-if="isMultiValue">
        <t-select
          v-model="value"
          :multiple="isMultiValue"
          filterable
          creatable
          :placeholder="isMultiValue ? '请添加' : '请选择'"
          :size="size"
          :options="valueOptions"
          class="condition-item-ele width208"
          @create="createValueOptions"
          @change="onValueChange"
          :minCollapsedNum="1"
          :disabled="disabled"
          :clearable="true"
        >
          <template #collapsedItems="{ collapsedSelectedItems, count }">
            <t-popup>
              <template #content>
                <p v-for="(item, index) in collapsedSelectedItems" :key="index" style="padding: 10px">
                  {{ item.label }}
                </p>
              </template>
              <t-tag v-show="count > 0" style="color: #222">...</t-tag>
            </t-popup>
          </template>
        </t-select>
      </template>
      <template v-else-if="isSingleValue">
        <t-input
          placeholder="请输入内容"
          :size="size"
          v-model="value"
          class="condition-item-ele width208"
          @change="onValueChange"
          :disabled="disabled"
        ></t-input>
      </template>
    </template>

    <!--<t-button-->
    <!--  theme="default"-->
    <!--  shape="circle"-->
    <!--  size="small"-->
    <!--  @click="handleRemoveFilterItem"-->
    <!--  class="condition-item-ele remove-btn"-->
    <!--&gt;-->
    <!--  <icon name="close" slot="icon" />-->
    <!--</t-button>-->

    <icon name="close" class="condition-item-ele remove-btn" @click="handleRemoveFilterItem" v-if="!disabled" />
  </div>
</template>

<script>
import BetweenInput from './between-input.vue';
import PropertySelector from './property-selector.vue';

export default {
  name: 'ConditionFilterItem',
  components: {
    BetweenInput,
    PropertySelector,
  },
  props: {
    propColumn: {
      type: String,
    },
    propChineseName: {
      type: String,
    },
    propConditionOperator: {
      type: String,
    },
    propValue: {
      type: [String, Array],
    },
    size: {
      type: String,
      default: 'small',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    conditionPropertyOptions: {
      type: Array,
      required: true,
    },
    conditionOperatorOptions: {
      type: Array,
      required: true,
    },
    allEventEventPropertyList: {
      type: Array,
      default: () => [],
    },
    filterEvents: {
      type: String,
      default: '',
    },
    filterPropertyFn: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      chineseName: this.propChineseName,
      column: this.propColumn,
      conditionOperator: this.propConditionOperator,
      value: '',
      valueOptions: [],
    };
  },
  computed: {
    isUserTag() {
      const findConditionProperty = this.conditionPropertyOptions.find(item => item.propertyName === this.column);
      return findConditionProperty && findConditionProperty.propertyType === 4;
    },
    isFirst() {
      const arr = ['is_first_pay', 'is_first_give_order', 'is_firstday_visit'];
      return arr.includes(this.column);
    },
    isMultiValue() {
      let flag = false;
      const findOperatorItem = this.conditionOperatorOptions.find(item => item.type === this.conditionOperator);
      if (findOperatorItem) {
        if (findOperatorItem.canMore > 1) {
          flag = true;
        }
      }
      return flag;
    },
    isSingleValue() {
      let flag = false;
      const findOperatorItem = this.conditionOperatorOptions.find(item => item.type === this.conditionOperator);
      if (findOperatorItem) {
        if (findOperatorItem.canMore === 1) {
          flag = true;
        }
      }
      return flag;
    },
    operatorOptions() {
      const findConditionProperty = this.conditionPropertyOptions.find(item => item.propertyName === this.column);
      const typeArr = ['eq', 'ne', 'null', 'notnull'];
      if (!findConditionProperty) return this.conditionOperatorOptions.filter(item => typeArr.includes(item.type));
      return this.conditionOperatorOptions
        .filter(item => item.javaType === findConditionProperty.propertyDataType)
        .map(item => ({
          label: item.desc,
          value: item.type,
        }));
    },
  },
  created() {
    this.value = this.translatePropValue();
    this.initValueOptions();
  },
  watch: {
    valueOptions: {
      deep: true,
      handler() {
        // console.log(this.valueOptions);
      },
    },
    propColumn() {
      this.column = this.propColumn;
    },
    propChineseName() {
      this.chineseName = this.propChineseName;
    },
    propConditionOperator() {
      this.conditionOperator = this.propConditionOperator;
    },
    propValue() {
      const value = this.translatePropValue();
      if (JSON.stringify(value) !== JSON.stringify(this.value)) {
        this.value = value;
        this.onValueChange();
      }
    },
  },
  methods: {
    translatePropValue() {
      if (this.isMultiValue) {
        if (Array.isArray(this.propValue)) {
          return [].concat(this.propValue);
        }
        return this.propValue && this.propValue.length > 0 ? this.propValue.split(',') : [];
      }
      return this.propValue || '';
    },
    initValueOptions() {
      let valueOptions = [];
      if (this.isUserTag) {
        valueOptions = this.userTagOptions(this);
      }
      if (this.isFirst) {
        valueOptions = this.firstOptions(this);
      }
      if (this.isFirst || this.isUserTag || this.value instanceof Array) {
        const valueArr = typeof this.value === 'string' ? [this.value] : this.value;
        valueArr.forEach(valItem => {
          const hasOption = valueOptions.find(option => option.value === valItem);
          if (!hasOption && valItem) {
            valueOptions.push({ label: valItem, value: valItem });
          }
        });
      }
      console.log(this.propChineseName, this.value, valueOptions);
      this.valueOptions = valueOptions;
    },
    createValueOptions(value) {
      if (value && value.trim()) {
        this.valueOptions.push({ label: value, value });
      }
    },
    handleRemoveFilterItem() {
      this.$emit('removeFilterItem');
    },
    onPropertyChange() {
      const findPropertyItem = this.conditionPropertyOptions.find(item => item.propertyName === this.column);
      if (findPropertyItem) {
        this.chineseName = findPropertyItem.propertyDesc;
        const tmpOperatorArr = this.conditionOperatorOptions.filter(
          item => item.javaType === findPropertyItem.propertyDataType,
        );
        if (tmpOperatorArr.length) {
          this.conditionOperator = tmpOperatorArr[0].type;
        } else {
          this.conditionOperator = '';
        }
      } else {
        this.conditionOperator = '';
      }
      this.onOperatorChange();
    },
    onOperatorChange() {
      this.value = this.isMultiValue ? [] : '';
      this.initValueOptions();
      this.updateAllProp({
        chineseName: this.chineseName,
        column: this.column,
        conditionOperator: this.conditionOperator,
        value: this.value,
      });
    },
    onValueChange() {
      this.updateAllProp({
        chineseName: this.chineseName,
        column: this.column,
        conditionOperator: this.conditionOperator,
        value: this.value,
      });
    },
    updateAllProp({ column, conditionOperator, chineseName, value } = {}) {
      this.$emit('update:propColumn', column);
      this.$emit('update:propConditionOperator', conditionOperator);
      this.$emit('update:propChineseName', chineseName);
      this.$emit('update:propValue', value instanceof Array ? value.join(',') : value);
    },
    userTagOptions() {
      if (!this || !this.column) {
        return [];
      }
      const findPropertyItem = this.conditionPropertyOptions.find(item => item.propertyName === this.column);
      return findPropertyItem && findPropertyItem.propertyType === 4 && findPropertyItem.propertyValueTipVOList
        ? findPropertyItem.propertyValueTipVOList.map(item => ({
            label: item.value,
            value: item.code,
          }))
        : [];
    },
    firstOptions() {
      if (!this || !this.column) {
        return [];
      }
      if (this.column === 'is_first_pay') {
        return [
          { label: '支付的新用户', value: '支付的新用户' },
          { label: '支付的老用户', value: '支付的老用户' },
        ];
      }
      if (this.column === 'is_first_give_order') {
        return [
          { label: '下单的新用户', value: '下单的新用户' },
          { label: '下单的老用户', value: '下单的老用户' },
        ];
      }
      if (this.column === 'is_firstday_visit') {
        return [
          { label: '访问的新用户', value: '访问的新用户' },
          { label: '访问的老用户', value: '访问的老用户' },
        ];
      }
      return [];
    },
  },
};
</script>

<style lang="less" scoped>
.condition-item {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  .condition-item-ele {
    &:not(:first-child) {
      margin-left: 15px;
    }

    &.multi-input-tags {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      max-width: 300px;
    }

    &.width100 {
      width: 100px;
    }

    &.width200 {
      width: 200px;
    }

    &.width300 {
      width: 300px;
    }

    &.width120 {
      width: 120px;
    }

    &.width208 {
      width: 208px;
    }
    &.remove-btn {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: #bbb;
      color: white;
      cursor: pointer;
    }
  }

  ::v-deep .t-select {
    display: flex;

    .t-tag:first-child {
      .t-tag--text {
        max-width: 70px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
